import React,{useState} from "react"

export default function ItemSelected({itemCount,itemValue,subscriptionPlan,handleCheckout}){
  const [loading,setLoading] = useState(false);

    return <div className="p_strip py-2"  id="checkout_div">
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-4">
          <p className="mb-0">
            <span className="me-1" id="total_addon_items">{itemCount}</span>Item Selected
          </p>
        </div>
        <div className="col-md-4">
          <p className="mb-0">Total Amount: $
            <span id="total_addon_price">{itemValue*(subscriptionPlan==="month"?1:12)}</span>/
            <span id="addon_type">{subscriptionPlan ==="month"?"Monthly":"Yearly"}</span>
          </p>
        </div>
        <div className="col-md-4">
          <button className={`btn btn-primary addon_checkout btn-sm ${loading ? 'spinner spinner-right disabled':''}`} value="click" onClick={()=>{setLoading(true);handleCheckout(()=>setLoading(false))}}>Check Out</button>
        </div>
      </div>
    </div>
  </div>
}